import React from "react";
import { ArrowUpRight, Download, FileText } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import axios from "axios";

const BrandCard = ({ brand }) => {
  const handleDownloadClick = () => {
      // Fire and forget download tracking
      try {
          const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
          axios.post(`${BACKEND_URL}/api/brands/${brand.id}/download`);
      } catch (e) {
          // Ignore errors
      }
  };

  return (
    <div className="group relative bg-dreibach-card border border-white/5 overflow-hidden h-[500px] flex flex-col transition-all duration-500 hover:border-dreibach-teal/50">
      
      {/* Image Area + Logo Overlay */}
      <div className="h-3/5 relative overflow-hidden bg-gray-900">
        <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-all duration-500 z-10" />
        <img 
          src={brand.image} 
          alt={brand.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-80 group-hover:opacity-100"
        />
        
        {/* Category Badge - REMOVED */}
        {/* <div className="absolute top-4 left-4 z-20">
             <Badge variant="secondary" className="bg-black/80 text-white hover:bg-black uppercase tracking-wider text-xs border border-white/10 rounded-none px-3 py-1">
                {brand.category}
             </Badge>
        </div> */}

        {/* LOGO OVERLAY - Top Aligned */}
        <div className="absolute inset-0 z-20 flex items-start justify-center p-8 pt-12">
            {brand.logo ? (
                 <img 
                    src={brand.logo} 
                    alt={brand.name}
                    className="max-w-[180px] max-h-[80px] object-contain drop-shadow-2xl brightness-0 invert" 
                 />
             ) : (
                 <h3 className="text-3xl font-black uppercase tracking-tight text-white drop-shadow-lg text-center">
                    {brand.name}
                 </h3>
             )}
        </div>
      </div>

      {/* Content Area */}
      <div className="h-2/5 p-8 flex flex-col justify-between relative z-20 bg-dreibach-card border-t border-white/5">
        <div>
          <p className="text-gray-400 text-sm leading-relaxed line-clamp-4 mb-4">
            {brand.description}
          </p>
        </div>
        
        <div className="flex flex-col gap-4 mt-auto">
           {/* Stats Line - REMOVED */}
           {/* <div className="flex items-center justify-between">
               <span className="text-xs uppercase tracking-widest text-dreibach-teal font-bold">
                  {brand.stats}
               </span>
           </div> */}

           {/* Download / Action Button */}
           {brand.pdfUrl ? (
                <a 
                    href={brand.pdfUrl} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="block w-full"
                    onClick={handleDownloadClick}
                >
                    <Button variant="outline" className="w-full border-white/10 hover:border-dreibach-teal hover:bg-dreibach-teal hover:text-white text-gray-300 uppercase text-xs font-bold tracking-widest rounded-none h-10 flex justify-between group/btn">
                        <span>Download Catalog</span>
                        <Download size={14} className="group-hover/btn:translate-y-0.5 transition-transform" />
                    </Button>
                </a>
           ) : (
                <Button disabled variant="outline" className="w-full border-white/5 bg-white/5 text-gray-600 uppercase text-xs font-bold tracking-widest rounded-none h-10 flex justify-between cursor-not-allowed">
                    <span>Catalog Unavailable</span>
                    <FileText size={14} />
                </Button>
           )}
        </div>
      </div>
    </div>
  );
};

export default BrandCard;
